import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { countryList, s3Static } from '../../../utils/constants'
import { getArticleDateTime, reviewedIso } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { AirconQuickLinks } from '../../../components/index/service-category/aircon-service/AirconQuickLinks'
import { airconDeals } from 'utils/airconDeals'
import { useEffect, useRef, useState } from 'react'
import { AirconGasBooking } from '@/index/service-category/aircon-service/AirconGasBooking'
import { AnimatePresence } from 'framer-motion'
import { openModal } from 'service/modal-service'
import { AirconItemSelection } from '@/index/service-category/aircon-service/AirconItemSelection'
import { AirconScope } from '@/index/service-category/aircon-service/AirconScope'
import { RequestProvider } from 'context/RequestContext'
import { Services } from '@/index/service/Services'
import { BottomButtons } from '@/index/service-category/aircon-service/BottomButtons'
import { AirconWhyUs } from '@/index/service-category/aircon-service/AirconWhyUs'
import { AirconBrandsWeSupport } from '@/index/service-category/aircon-service/AirconBrandsWeSupport'
import { AirconCustomerReviews } from '@/index/service-category/aircon-service/AirconCustomerReviews'
import { getTestimonials } from 'api/user/profile-api'
import { getAcTestimonials, setAcTestimonials } from 'service/testimonial-store'
import { buildAirconServiceGraph } from 'utils/aircon-page-schema'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    const currencyCd = "SGD"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const testimonials = getAcTestimonials().length > 0 ? getAcTestimonials() : await getTestimonials("Aircon Services", 0, 6)
    setAcTestimonials(testimonials)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Aircon Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { month, year } = getArticleDateTime()
    const modifiedDate = reviewedIso(CONTENT_REVIEWED)
    const airconBlogs = blogsMaster['hvac-services'].blogArray

    const getLocalityList = () => {
        for(let x in countryList){
            if(countryList[x].country_name === countryName){
                return countryList[x].localityList
            }
        }
    } 

    const localityList = getLocalityList()

    const gasRefillCosts = [...airconDeals].filter(d => d.serviceType.includes("gasRefill", "gasRefillHalf"))

  return {
      props: {
        requestCategorySettings,
        modifiedDate,
        month,
        year,
        airconBlogs,
        currencyCd,
        localityList,
        gasRefillCosts,
        countryName,
        testimonials
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 259200, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const airconBlogs = props.airconBlogs
    const requestCategorySettings = props.requestCategorySettings;
    const currencyCd = props.currencyCd
    const localityList = props.localityList
    const gasRefillCosts = props.gasRefillCosts
    const countryName = props.countryName
    const requestType = 'Aircon Services'
    const testimonials = props.testimonials

    const [ requestForm, setRequestForm ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ isCustomBook, setIsCustomBook ] = useState(false)
    const [ isShowAirconItemSelection, setIsShowAirconItemSelection ] = useState(false)
    const [ isShowJobScope, setIsShowJobScope ] = useState(false)
    const [ scopeServiceType, setScopeServiceType ] = useState("gasRefill")
    const [ scopeUnitType, setScopeUnitType ] = useState("")

    const showJobScope = (serviceType, unitType) => {
        setScopeServiceType(serviceType)
        setScopeUnitType(unitType)
        openModal(setIsShowJobScope)
    }
    
    const openRequestForm = () => {
        window.scrollTo({ top: 0 });
        openModal(setRequestForm)
        // setRequestForm(true)
    }

  return (
    <>
      <Head>
        <title>Trusted Aircon Gas Top Up Service In Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Get aircon gas top up in Singapore at an affordable pricing. R22 refrigerant can cost between $40 and $100, whereas R410A can cost between $60 and $150. StringsSG offers the best aircon gas top-up services in town."/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-gas-top-up" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Trusted Aircon Gas Top Up Service In Singapore`}/>
        <meta property="og:description" content="Get aircon gas top up in Singapore at an affordable pricing. R22 refrigerant can cost between $40 and $100, whereas R410A can cost between $60 and $150. StringsSG offers the best aircon gas top-up services in town." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-30T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon/refrigerant-gas-R22.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon/refrigerant-gas-R22.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-gas-top-up"/>
        <meta name="twitter:title" content={`Trusted Aircon Gas Top Up Service In Singapore`}/> 
        <meta name="twitter:description" content="Get aircon gas top up in Singapore at an affordable pricing. R22 refrigerant can cost between $40 and $100, whereas R410A can cost between $60 and $150. StringsSG offers the best aircon gas top-up services in town."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/aircon-servicing-singapore/aircon-gas-top-up"/>
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(buildAirconServiceGraph({
            path: '/sg/aircon-servicing-singapore/aircon-gas-top-up',
            pageName: 'Trusted Aircon Gas Top Up Service In Singapore',
            description: 'Get aircon gas top up in Singapore at an affordable pricing. R22 refrigerant can cost between $40 and $100, whereas R410A can cost between $60 and $150. StringsSG offers the best aircon gas top-up services in town.',
            serviceName: 'Aircon Gas Top Up Singapore',
            serviceType: 'Aircon Gas Top Up',
            image: 'https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/aircon/refrigerant-gas-R22.png',
            datePublished: '2025-01-29T07:30:46+00:00',
            modifiedDate,
            breadcrumbName: 'Aircon Gas Top Up',
          })) }}
        />
        </Head>
        <div>
            <RequestProvider>
                <section id="aircon-gas-refill-booking" className="relative">                
                    <div className="-mt-14 relative w-full aspect-21/9 sm:h-200 overflow-hidden">
                        <Image
                            className='bg-linear-to-br from-slate-800 to-orange-300'
                            src={s3Static + "blog/living/aircon/chinese-aircon-service-man-smiling.jpg"}
                            fill
                            style={{ objectFit: 'cover' }}
                            alt="aircon gas top up"
                            priority={true}
                            sizes="100vw"
                        />
                    </div>     
                    <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>       
                        <AirconGasBooking
                            setRequestForm={setRequestForm}
                            gasRefillCosts={gasRefillCosts}
                            currencyCd={currencyCd}
                            setIsQuickBook={setIsQuickBook}
                            setIsCustomBook={setIsCustomBook}
                            setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                            showJobScope={showJobScope}
                            title="Aircon Gas Top-Up Singapore"
                            subtitle="Top-Up Your Aircon Gas Efficiently with StringsSG"
                        />
                    </div>
                    {requestForm && 
                        <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} isCustomBook={isCustomBook} asSheet/>
                    }
                </section>
                {isShowJobScope &&
                    <AnimatePresence>
                        <AirconScope
                            setIsShowJobScope={setIsShowJobScope}
                            serviceType={scopeServiceType}
                            unitType={scopeUnitType} />
                    </AnimatePresence>
                }
                {isShowAirconItemSelection &&
                    <AnimatePresence>
                        <AirconItemSelection setIsShowAirconItemSelection={setIsShowAirconItemSelection} setRequestForm={setRequestForm} setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook} openRequestForm={openRequestForm} userId={null}/> 
                    </AnimatePresence>
                }
            </RequestProvider>
            <section className="relative px-4 py-5 md:py-10">
                <div className="max-w-5xl mx-auto space-y-4 md:space-y-8">  
                    <header className="text-center space-y-2">
                        <h2 className="text-3xl md:text-4xl font-bold">
                            StringsSG Aircon Gas Top-Up Singapore
                        </h2>
                        <p className="text-sm text-gray-500">
                            By StringsSG – Trusted Local Home Service Partner
                        </p>
                        <p className="text-xs text-gray-400">
                            BCA-Certified Aircon Technicians
                        </p>
                    </header>
                    <div className="max-w-4xl mx-auto bg-white/80 backdrop-blur-md shadow-xl rounded-3xl p-5 sm:p-6 space-y-4 border border-amber-200">
                        <p className="text-gray-700 leading-relaxed">
                            Air conditioning systems require refrigerant gases like <strong>R22, R410A</strong>, or <strong>R32</strong> to function effectively. Low gas levels cause poor cooling, compressor strain, and higher electricity bills. At StringsSG, our experienced and BCA-certified technicians use calibrated gauges to diagnose refrigerant issues accurately and perform top-ups in a safe, eco-friendly manner.
                        </p>
                        <p className="text-gray-700">
                            All gas refill services follow NEA-compliant safety protocols, ensuring both optimal cooling performance and environmental responsibility. We source our refrigerants only from licensed suppliers to guarantee authenticity and quality.
                        </p>
                        <p className="text-gray-700">
                            If you&apos;re on a maintenance package, refrigerant level checks are included in every visit. Refills are charged separately based on gas type and quantity, with transparent pricing displayed before service begins.
                        </p>
                        <div className="text-sm text-gray-600 border-t border-amber-100 pt-4">
                            <strong>Expert Tip:</strong> A healthy refrigerant level not only improves cooling but also extends your aircon&apos;s lifespan. Schedule a check at least once a year for the best performance.
                        </div>
                    </div>
                    <div className="rounded-xl overflow-hidden shadow-lg max-w-2xl mx-auto">
                        <div className="relative h-40 sm:h-60">
                            <Image
                            className="object-cover"
                            src={s3Static + "blog/living/aircon-gas.jpg"}
                            fill
                            sizes="(max-width: 768px) 100vw, 672px"
                            alt="Technician topping up aircon gas"
                            placeholder="blur"
                            blurDataURL={s3Static + "placeholder.png"}
                            />
                        </div>
                        <figcaption className="text-center text-xs text-gray-500 italic py-2">
                            StringsSG technician performing gas top-up
                        </figcaption>
                        </div>

                        <div className="space-y-6">
                        <h2 className="text-2xl md:text-3xl font-bold text-center uppercase">Gas Top-Up Pricing</h2>
                        <p className="text-gray-700 text-center max-w-2xl mx-auto">
                            Prices depend on gas type, volume required, and your aircon system. Here&apos;s a typical range in Singapore:
                        </p>

                        <div className="max-w-md mx-auto bg-white/70 border border-amber-200 rounded-xl overflow-hidden shadow-md">
                            <table className="w-full text-sm text-gray-700 text-center">
                                <thead className="bg-amber-100 text-amber-800 uppercase">
                                    <tr>
                                    <th className="p-3 border-b">Gas Type</th>
                                    <th className="p-3 border-b">Price (SGD)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-orange-50 transition">
                                    <td className="p-3 border-b">R410A</td>
                                    <td className="p-3 border-b">{currencyCd} 60 – {currencyCd} 150</td>
                                    </tr>
                                    <tr className="hover:bg-orange-50 transition">
                                    <td className="p-3 border-b">R32</td>
                                    <td className="p-3 border-b">{currencyCd} 100 – {currencyCd} 200</td>
                                    </tr>
                                    <tr className="hover:bg-orange-50 transition">
                                    <td className="p-3 border-b">R22</td>
                                    <td className="p-3 border-b">{currencyCd} 40 – {currencyCd} 100</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="max-w-4xl mx-auto pt-10 px-4 space-y-6">
                        <h2 className="text-2xl md:text-3xl font-bold uppercase text-center text-gray-800 dark:text-gray-100">
                            Signs Your Aircon Needs Gas Top-Up
                        </h2>

                        <ul className="space-y-4">
                            {[
                            { icon: "🌬️", title: "Weak cooling", desc: "Air isn’t as cold as before." },
                            { icon: "⏱️", title: "Longer cycles", desc: "Takes longer to cool the room." },
                            { icon: "🔄", title: "Compressor never stops", desc: "Constant or irregular operation." },
                            { icon: "❄️", title: "Ice buildup", desc: "Frost on coils or copper pipes." },
                            { icon: "💨", title: "Hissing sounds", desc: "Could indicate a refrigerant leak." },
                            { icon: "⚡", title: "High electricity bills", desc: "Caused by poor cooling efficiency." },
                            ].map((item, index) => (
                            <li
                                key={index}
                                className="flex items-start gap-3 text-gray-700 dark:text-gray-200"
                            >
                                <span className="text-lg">{item.icon}</span>
                                <span>
                                <strong>{item.title}</strong> – {item.desc}
                                </span>
                            </li>
                            ))}
                        </ul>

                        <p className="text-gray-600 dark:text-gray-300 pt-4 leading-relaxed">
                            If you notice any of these signs, don’t delay. <strong className="text-gray-800 dark:text-white">StringsSG’s certified technicians</strong> can inspect, diagnose, and safely refill your aircon gas.
                            Learn more about{" "}
                            <Link href="/sg/aircon-servicing-singapore/aircon-gas-leakage" className="text-orange-600 underline">
                            gas leakage
                            </Link>
                            .
                        </p>
                    </div>
                </div>
            </section>
            <AirconWhyUs/>
            <AirconCustomerReviews testimonials={testimonials} />
            <AirconBrandsWeSupport/>
            <div className="max-w-5xl mx-auto py-5 md:py-10 px-4 leading-7 md:leading-8 text-gray-800 dark:text-gray-100">
                <section className="py-5 md:py-10 space-y-3 md:space-y-4">
                    <h2 className="text-center text-xl md:text-2xl font-bold uppercase tracking-wide  flex items-center justify-center gap-2">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 10h4l3-6 4 14 3-6h4" /></svg>
                        Types of A/C Refrigerant Gas
                    </h2>
                    <div className="py-3 space-y-2">
                    <div className="relative h-40 md:h-60 w-full max-w-md mx-auto rounded-xl overflow-hidden shadow-md">
                        <Image className="rounded-lg" src={s3Static + "blog/living/aircon/refrigerant-gas-R22.png"} fill sizes="(max-width: 768px) 100vw, 448px" style={{ objectFit: 'cover' }} placeholder="blur" blurDataURL={s3Static + "placeholder.png"} alt="Aircon refrigerant gas R22" />
                    </div>
                    <figcaption className="text-xs italic text-center text-gray-500 dark:text-gray-400">R22 gas cylinders</figcaption>
                    </div>

                    <ul className="space-y-5 text-sm md:text-base">
                    <li>
                        <h3 className="text-lg font-semibold">1. R-22 (Chlorodifluoromethane)</h3>
                        <p>Once widely used, R-22 is being phased out globally due to ozone depletion issues under the Montreal Protocol.</p>
                    </li>
                    <li>
                        <h3 className="text-lg font-semibold">2. R-410A (Puron)</h3>
                        <p>R-410A replaced R-22 in many systems. It&apos;s more environmentally friendly as it doesn’t deplete the ozone layer.</p>
                    </li>
                    <li>
                        <h3 className="text-lg font-semibold">3. R-134a (1,1,1,2-Tetrafluoroethane)</h3>
                        <p>Used in automotive and commercial systems, R-134a has no ozone depletion effect but contributes to global warming.</p>
                    </li>
                    <li>
                        <h3 className="text-lg font-semibold">4. R-407C</h3>
                        <p>Designed to replace R-22 in existing systems, R-407C is ozone-safe but still contributes to global warming.</p>
                    </li>
                    <li>
                        <h3 className="text-lg font-semibold">5. R-32 (Difluoromethane)</h3>
                        <p>Common in newer residential units, R-32 offers lower global warming potential compared to many HFCs.</p>
                    </li>
                    <li>
                        <h3 className="text-lg font-semibold">6. R-290 (Propane) and R-600a (Isobutane)</h3>
                        <p>Eco-friendly hydrocarbon refrigerants with very low global warming impact, used in small-capacity systems.</p>
                    </li>
                    </ul>

                    <p className="pt-5">
                    Refrigerant use and availability are changing due to evolving regulations and environmental concerns. Stay updated with newer, safer alternatives.
                    </p>
                </section>

                <div className="relative h-40 md:h-60 w-full max-w-md mx-auto mt-4 md:mt-6 rounded-xl overflow-hidden shadow-md">
                    <Image className="rounded-lg" src={s3Static + "blog/living/aircon/refrigerant-gas-410A.png"} fill sizes="(max-width: 768px) 100vw, 448px" style={{ objectFit: 'contain' }} placeholder='blur' blurDataURL={s3Static + "placeholder.png"} alt='Aircon refrigerant gas R410A' />
                </div>
                <figcaption className="text-xs italic text-center text-gray-500 dark:text-gray-400">R410A gas cylinders</figcaption>

                <section className="py-5 md:py-10 space-y-3 md:space-y-4">
                    <h2 className="text-center text-xl md:text-2xl font-bold uppercase">Should You Top Up Aircon Refrigerant Gas Yourself?</h2>
                    <div className="space-y-3">
                    <p>
                        Topping up aircon refrigerant gas yourself is not recommended. It involves hazardous substances and requires certifications.
                    </p>
                    <p>
                        Mishandling refrigerants like R-410A or R-22 can cause health hazards and damage your unit. Only licensed HVAC technicians should handle them.
                    </p>
                    <p>
                        If your system isn&apos;t cooling well, seek help from certified professionals to ensure safety and efficiency.
                    </p>
                    </div>
                </section>
            </div>
            {/* <AcServiceLocality localityList={localityList}/> */}
            {/* <AirconBacklink/> */}
            <BlogsList blogs={airconBlogs}/>
            <AirconQuickLinks/>
            {!requestForm &&
                <BottomButtons countryName={countryName}/>
            }
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
